import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Spinner } from "@/components/ui/spinner";
import { usePublicTenantSlug } from "@/hooks/use-public-tenant-slug";
import { useSyncPublicRestaurantAnonScope } from "@/hooks/use-sync-public-restaurant-anon-scope";
import { useRestaurantBySlug } from "@/rc/hooks/restaurant/use-restaurant";

/**
 * Public shell for optional `:slug?` routes — same tenant resolve / anon scope / gates as {@link OrderingLayout},
 * with `common.publicTenant` copy. Ordering adds language switcher, order namespace, and its own error boundary.
 */
export function SlugLayout() {
  const slug = usePublicTenantSlug();
  const { t } = useTranslation("common");

  const restaurantQuery = useRestaurantBySlug();
  const restaurantId = restaurantQuery.data?.id;

  useSyncPublicRestaurantAnonScope(restaurantId);

  const showOutlet =
    Boolean(slug) && restaurantQuery.isSuccess && Boolean(restaurantId);

  return (
    <div className="min-h-screen bg-background">
      {restaurantQuery.isError ? (
        <div className="flex min-h-screen items-center justify-center p-6 text-center text-muted-foreground">
          {t("publicTenant.loadError")}
        </div>
      ) : !slug ? (
        <div className="flex min-h-screen items-center justify-center p-6 text-center text-muted-foreground">
          {t("publicTenant.missingSlug")}
        </div>
      ) : restaurantQuery.isSuccess && !restaurantId ? (
        <div className="flex min-h-screen items-center justify-center p-6 text-center text-muted-foreground">
          {t("publicTenant.restaurantNotFound")}
        </div>
      ) : !showOutlet ? (
        <div className="flex min-h-screen items-center justify-center">
          <Spinner className="h-8 w-8 text-muted-foreground" />
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
}
